import { activePortalSettings } from '../config/portal-regions';
import Clarity from '@microsoft/clarity';
export const CLARITY_PROJECT_ID = activePortalSettings.clarityProjectId;
let clarityInitialized = false;
type ClarityWindow = Window & { clarity?: (...args: unknown[]) => void };
export const initializeClarity = () => {
    if (typeof window === 'undefined' || !CLARITY_PROJECT_ID || clarityInitialized) return;
    try {
        Clarity.init(CLARITY_PROJECT_ID);
        (window as ClarityWindow).clarity?.('consentv2', { ad_Storage: 'denied', analytics_Storage: 'granted' });
        clarityInitialized = true;
    } catch (error) { console.error('Failed to initialize Clarity:', error); }
};
export const clearClarity = () => {
    if (typeof window === 'undefined') return false;
    const wasLoaded = clarityInitialized;
    if (wasLoaded) (window as ClarityWindow).clarity?.('consentv2', { ad_Storage: 'denied', analytics_Storage: 'denied' });
    clarityInitialized = false;
    for (const name of ['_clck', '_clsk']) {
        const domains = ['', window.location.hostname, ...['.simplysend.email', '.simplysend.dev', '.simplysend.ai'].filter(domain => window.location.hostname.endsWith(domain))];
        for (const domain of domains) document.cookie = `${name}=; Max-Age=0; Path=/${domain ? `; Domain=${domain}` : ''}`;
    }
    return wasLoaded;
};
